import { PAYMENT_METHODS } from '../../../components/order/const';

export default {
  props: {
    /** 确认收货拦截函数(二次确认) */
    confirmReceipt: {
      type: Function | undefined
    },

    /** 重新发起支付结果回调 */
    confirmPay: {
      type: Function | undefined
    }
  },

  methods: {
    /** 确认收货 */
    async toConfirmReceipt(orderNo) {

      if (this.confirmReceipt) {
        const isConfirm = await this.confirmReceipt();
        if (!isConfirm) return false;
      }

      await this.orderSdk.setOrderFinish({
        orderNo
      });

      this.$emit('confirm-receipt-success', orderNo);

      return true;
    },

    /** 重新发起支付 */
    async toConfirmPay(orderNo, options) {
      const paymentMethod = options?.paymentMethod || PAYMENT_METHODS.WECHAT;

      if (this.confirmPay) {
        const hasPay = await this.confirmPay(orderNo, { paymentMethod });
        if (!hasPay) return false;
      }

      this.$emit('pay-success', orderNo, { paymentMethod });

      return true;
    },

    /** 更新订单信息 */
    updateDetail(orderNo) {
      return this.orderSdk.getOrderDetail({
        orderNo,
        syncPayStatus: 'Y'
      });
    },

    /** 时间转换 */
    formatTimeStamp(timestamp, format = 'yyyy.mm.dd hh:mm') {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return format
        .replace('yyyy', year)
        .replace('mm', month)
        .replace('dd', day)
        .replace('hh', hours)
        .replace('mm', minutes);
    },
  }
};
